module.exports = __webpack_public_path__ + "static/media/gameStart_1.c64516f3.mp3";